import Icon from "@client/controls/Icon/component";
import { IconType } from "@common/declarations";
import * as React from "react";
import { type KnowledgeBase } from "../types";

type Props = {
  articleCategories: KnowledgeBase.Api.ArticleCategory[];
  articles: KnowledgeBase.Api.Article[];
  getCategoryArticlesCount: (category: KnowledgeBase.Api.ArticleCategory) => string;
  setActiveItemState: (newState: KnowledgeBase.View.ActiveItem | null) => void;
  style: React.CSSProperties;
};
const KnoledgeBaseCategoryNested = (props: Props) => (
  <div className="knowledge_base_nested_container">
    <div style={props.style} className="knowledge_base_container">
      {props.articleCategories.map((category) => (
        <div
          key={category.articleCategoryId}
          onClick={() => props.setActiveItemState({ type: "category", category: category })}
          className="category_title"
        >
          <h5>{category.name}</h5>
          <span>
            {props.getCategoryArticlesCount(category)}
            <Icon className="chevron" iconClassName={IconType.ChevronRight} />
          </span>
        </div>
      ))}
      {props.articles.map((article) => (
        <div
          key={article.articleId}
          onClick={() => props.setActiveItemState({ type: "article", article: article })}
          className="article_title"
        >
          <Icon className="article_icon" iconClassName={IconType.Memo} />
          {article.title}
        </div>
      ))}
    </div>
  </div>
);

export default KnoledgeBaseCategoryNested;
